localStorage.storageTime = localStorage.storageTime ? localStorage.storageTime : new Date().getTime();
if (new Date().getTime() - localStorage.storageTime > 43200000 || !localStorage.storageExpire) {
    localStorage.storageTime = new Date().getTime();
    localStorage.storageExpire = true;
} else {
    localStorage.storageExpire = false;
}


export function hasOwn(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}

export function isVNode(node) {
    return node !== null && typeof node === 'object' && hasOwn(node, 'componentOptions');
};

export default {
    hasOwn,
    isVNode
}